<template>
  <VdSelect
    v-loading="segmentsLoading"
    class="segments-select-input-component"
    :multiple="multiple"
    :placeholder="placeholder"
    :choices="segmentChoices"
    :disabled="disabled"
    :model-value="modelValue"
    @update:model-value="onChange"
  />
</template>

<script lang="ts">
import { VdSelect } from "@voodoo.io/voodoo-ui";
import { computed, defineComponent, PropType } from "vue";

import { useSegmentsSelectInputQuery } from "@/graphql/generated-types";

export default defineComponent({
  name: "SegmentsSelectInput",

  components: {
    VdSelect,
  },

  props: {
    gameId: {
      type: String,
      required: true,
    },

    versionId: {
      type: String,
      required: true,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      type: [String, Array] as PropType<string | string[]>,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["update:modelValue"],

  setup(props, { emit }) {
    const { result, loading: segmentsLoading } = useSegmentsSelectInputQuery({
      gameId: props.gameId,
      versionId: props.versionId,
    });

    const segments = computed(() => result.value?.game?.version?.segments ?? []);

    const segmentChoices = computed(() => segments.value.map(({ id, name }) => ({ label: name, value: id })));

    const onChange = (value: string | string[]) => {
      emit("update:modelValue", value);
    };

    const placeholder = computed(() => (props.multiple ? "Select one or more segments" : "Select a segment"));

    return {
      segmentChoices,
      segmentsLoading,
      onChange,
      placeholder,
    };
  },
});
</script>
